import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { RealizarManutencao } from "../typings";
import http from "infra/http";

export function useRealizacaoManutencao(
  id?: string | undefined,
  dataPrevistaInicial?: string | null
) {
  return useQuery<RealizarManutencao, AxiosError>(
    `/v1/manutencao/${id}/realizacao/${dataPrevistaInicial}`,
    async () => {
      const { data } = await http.get<RealizarManutencao>(
        `/v1/manutencao/${id}/realizacao/${dataPrevistaInicial}`
      );

      return data;
    },
    { enabled: !!id && !!dataPrevistaInicial }
  );
}
